import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import WithdrawalComponent from './withdrawal.component';
import WithdrawalModalComponent from './component/success.modal.component';
import WithdrawalErrorModalComponent from './component/error.modal.component';
import bankWithdrawalFormComponent from './component/form/bank/bank-withdrawal-form.component';
import skrillWithdrawalFormComponent from './component/form/skrill/skrill-withdrawal-form.component';
import ecopayzWithdrawalFormComponent from './component/form/ecopayz/ecopayz-withdrawal-form.component';
import netellerWithdrawalFormComponent from './component/form/neteller/neteller-withdrawal-form.component';
import bitcoinWithdrawalFormComponent from './component/form/bitcoin/bitcoin-withdrawal-form.component';
import switchAuthDirective from './directive/switch-auth.directive';

import WithdrawalStore from './service/withdrawal.store';

let withdrawalModule = angular.module('withdrawal', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
  .state('withdrawal', {
    parent: 'standardLayout',
    url: '/transactions/withdrawal',
    component: 'withdrawal',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  })
  ;
})
.component('withdrawal', WithdrawalComponent)
.component('bankwithdrawalForm', bankWithdrawalFormComponent)
.component('skrillwithdrawalForm', skrillWithdrawalFormComponent)
.component('ecopayzwithdrawalForm', ecopayzWithdrawalFormComponent)
.component('netellerwithdrawalForm', netellerWithdrawalFormComponent)
.component('bitcoinWithdrawalForm', bitcoinWithdrawalFormComponent)
.component('withdrawalSuccessModal', WithdrawalModalComponent)
.component('withdrawalErrorModal', WithdrawalErrorModalComponent)
.service('WithdrawalStore', WithdrawalStore)
.directive('switchAuth', switchAuthDirective)
.name;

export default withdrawalModule;



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/withdrawal.js